import { CombinedError } from '@urql/core';

import { findGraphqlErrorWithCode } from '~/utils/graphql';

/**
 * The code the server refuses a public sign-up with when the email sits in a domain a school
 * controls. That person's account belongs on the schools site, so the refusal is a place to send
 * them, never an inline error.
 */
export const SCHOOL_ACCOUNT_EMAIL_ERROR_CODE = 'SCHOOL_ACCOUNT_EMAIL';

export const isSchoolAccountEmailError = (error: unknown): boolean =>
  error instanceof CombinedError && !!findGraphqlErrorWithCode(error, SCHOOL_ACCOUNT_EMAIL_ERROR_CODE);
